import * as types from '@/store/types';
import { defaultPrivileges } from '@/helpers/privileges';
import set from 'lodash/set';
import get from 'lodash/get';
import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import { flatten } from 'flat';
import { getGlobalSavedElement, saveGlobalElement, resetGlobalElement } from 'shared-lib/helpers/local-storage';

const areDeveloperToolsEnabled = process.env.NODE_ENV === 'development' && process.env.VUE_APP_SHOW_DEVELOPER_TOOLS;

const state = {
    currentUserPrivileges: cloneDeep(defaultPrivileges),
};

const getters = {
    currentUserPrivileges: state => state.currentUserPrivileges,

    currentUserModuleIsReadOnly: state => (module, item) => {
        const isModuleReadOnly = !get(state.currentUserPrivileges, module)?.write; // TODO: shouldn't it use "update" field instead?
        const isSpecifiedItemReadOnly = typeof item !== 'undefined'
            ? String(get(state.currentUserPrivileges, module)?.specified?.item) === String(item) && !get(state.currentUserPrivileges, module)?.specified?.write
            : false
        ;

        return isModuleReadOnly || isSpecifiedItemReadOnly;
    },

    currentUserHasModuleAccess: state => (module, right = 'read', item) => {
        const isModuleAvailable = !!get(state.currentUserPrivileges, module)?.[right];
        const isSpecifiedItemAvailable = typeof item !== 'undefined' && String(get(state.currentUserPrivileges, module)?.specified?.item) === String(item)
            ? !!get(state.currentUserPrivileges, module)?.specified?.[right]
            : true
        ;

        return isModuleAvailable && isSpecifiedItemAvailable;
    },

    arePrivilegesChanged: state => {
        const privilegesFlat = flatten(state.currentUserPrivileges);
        return Object.keys(privilegesFlat).some(field =>
            field.endsWith('.specified.item')
                ? privilegesFlat[field]
                : !privilegesFlat[field]
        );
    },
};

const actions = {
    updateCurrentUserPrivileges ({ commit }, payload) {
        commit(types.UPDATE_CURRENT_USER_PRIVILEGES, payload);

        saveGlobalElement('currentUserPrivileges', {
            ...getGlobalSavedElement('currentUserPrivileges'),
            [payload.module]: payload.value,
        });
    },

    populateCurrentUserPrivileges ({ commit, dispatch, rootGetters }) {
        dispatch('populateCurrentUserModulesRestrictions');
        commit(types.POPULATE_CURRENT_USER_PRIVILEGES, rootGetters.currentUserModulesRestrictions);
    },

    resetCurrentUserPrivileges ({ commit, rootGetters }) {
        resetGlobalElement('currentUserPrivileges');

        commit(types.POPULATE_CURRENT_USER_PRIVILEGES, rootGetters.currentUserModulesRestrictions);
    },
};

const mutations = {
    [types.UPDATE_CURRENT_USER_PRIVILEGES] (state, data) {
        const { module, value } = data;
        set(state.currentUserPrivileges, module, value);
    },

    [types.POPULATE_CURRENT_USER_PRIVILEGES] (state, currentUserModulesRestrictions) {
        const savedChanges = getGlobalSavedElement('currentUserPrivileges');
        let privileges = merge(cloneDeep(defaultPrivileges), cloneDeep(currentUserModulesRestrictions));

        // TODO: are defaultPrivileges really needed? delete if not

        if (areDeveloperToolsEnabled && savedChanges) {
            Object.keys(savedChanges).forEach(module =>
                set(privileges, module, savedChanges[module])
            );
        }
        else {
            resetGlobalElement('currentUserPrivileges');
        }

        state.currentUserPrivileges = cloneDeep(privileges);
    },
};

export default {
    getters,
    state,
    actions,
    mutations,
};
